import { useCallback, useContext, useState } from 'react';

import { useToast } from '@kanda-libs/ks-design-library';
import { services, useSubmit } from '@kanda-libs/ks-frontend-services';

import useReloadInitialData from 'hooks/useReloadInitialData';
import { extractErrorMessage, serviceConvert } from 'utils';

export interface MarkAllAsPaidButtonPropsHook {
  onClick: () => void;
  isSubmitting: boolean;
  error: string;
}

export default function useMarkAllAsPaidButtonProps(): MarkAllAsPaidButtonPropsHook {
  const [error, setError] = useState<string>('');

  const { showError, showSuccess } = useToast();

  const refreshAll = useReloadInitialData();

  const { submit: markAllAsPaid, isSubmitting = false } = useSubmit(
    serviceConvert(services.job.payoutsJob),
  );

  const onClick = useCallback(() => {
    markAllAsPaid({ params: { job_type: 'standard' } }).then(
      ({ error, ...args }) => {
        if (error) {
          const message = extractErrorMessage(error);
          showError(message || 'Error marking some/all jobs as paid');
          setError(error as string);
          return;
        }
        refreshAll();
        showSuccess('Jobs marked as paid');
      },
    );
  }, [markAllAsPaid, showError, showSuccess, refreshAll]);

  return {
    onClick,
    isSubmitting,
    error,
  };
}
